import React from "react";
import { Typography, Tooltip } from "@material-ui/core";

export const quoteIn = lower => (
  <Tooltip title="Required for Quote">
    <Typography
      variant="button"
      style={{
        position: "relative",
        top: lower ? "20px" : "0px",
        marginRight: "8px",
        color: "#9568ff",
        cursor: "default"
      }}
    >
      <strong>Q</strong>
    </Typography>
  </Tooltip>
);

export const astuteIn = lower => (
  <Tooltip title="Required for Astute">
    <Typography
      variant="button"
      style={{
        position: "relative",
        top: lower ? "20px" : "0px",
        marginRight: "8px",
        color: "#75ce91",
        cursor: "default"
      }}
    >
      <strong>A</strong>
    </Typography>
  </Tooltip>
);



// WEBPACK FOOTER //
// ./src/views/Clients/components/FieldIndicators.jsx